module.exports = __webpack_public_path__ + "static/media/Prateek Hejmady.87a7a19f.png";